import axios from 'axios';
// 后端地址
// const baseURL = 'https://toolkits-api.myjk666.cn/'  //美耀
const baseURL = 'https://tcm-api.tangzhiguanjia.com/'; //中医诊所
const crmBaseURL = 'https://crm-api.tangzhiguanjia.com/';
export const CRM_TOKEN_STORAGE_KEY = 'crmToken';
//获取Url 中的 corpId 跟 agentId  
let corpIdParam = null;
let agentIdParam = null;
try {
    const currentUrl = new URL(window.location.href);
    corpIdParam = currentUrl.searchParams.get('corpId');
    agentIdParam = currentUrl.searchParams.get('agentId');
}
catch (e) {
    // ignore
}
// 兼容 hash 路由中的查询参数（/#/path?corpId=xxx&agentId=yyy）
if ((!corpIdParam || !agentIdParam) && window.location.hash) {
    const hash = window.location.hash;
    const qIndex = hash.indexOf('?');
    if (qIndex !== -1) {
        const hashQuery = hash.slice(qIndex + 1);
        const hashParams = new URLSearchParams(hashQuery);
        if (!corpIdParam)
            corpIdParam = hashParams.get('corpId');
        if (!agentIdParam)
            agentIdParam = hashParams.get('agentId');
    }
}
const commonHeaders = {
    corpId: corpIdParam || '' // 从 url 获取
};
// 创建主域名 axios 实例
const api = axios.create({
    baseURL,
    headers: commonHeaders,
    proxy: false
});
// 创建 CRM 域名 axios 实例
const crmApi = axios.create({
    baseURL: crmBaseURL,
    headers: commonHeaders,
    proxy: false
});
const appendCrmTokenHeader = (config) => {
    const token = window.localStorage.getItem(CRM_TOKEN_STORAGE_KEY);
    if (!token)
        return config;
    config.headers = config.headers || {};
    // 兼容后端不同鉴权方式：Authorization / token
    config.headers.Authorization = `Bearer ${token}`;
    config.headers.token = token;
    return config;
};
api.interceptors.request.use(appendCrmTokenHeader);
crmApi.interceptors.request.use(appendCrmTokenHeader);
// 根据 userId 获取 user 信息
export const fetchUser = async (userId) => {
    const response = await api.get('/api/qywx-proxy/user/get', {
        params: {
            userid: userId
        }
    });
    return response.data;
};
// 根据 externalUserId 获取 externalUser 信息
export const fetchExternalUser = async (externalUserId, cursor) => {
    const response = await api.get('api/work/member/userInfo', {
        params: {
            external_userid: externalUserId,
            cursor
        }
    });
    return response.data.data;
};
// 根据 code 换取 userId，作为用户身份验证
export const fetchUserId = async (code) => {
    const response = await api.post('api/login/codeLogin', {
        code: code
    });
    console.log(response.data);
    return response.data.data.userid;
};
// 获取签名
export const fetchSignatures = async () => {
    console.log(window.location.href);
    const response = await api.get('api/work/signatures', {
        params: {
            url: window.location.href
        }
    });
    console.log(response.data);
    return response.data.data;
};
export const tableMmol = async (externalUserId, page, limit) => {
    const response = await api.get('api/work/health/tableMmol', {
        params: {
            external_userid: externalUserId,
            page: page,
            limit: limit,
        }
    });
    return response.data.data;
};
//绑定手机号
export const bindPhone = async (externalUserId, phone) => {
    const response = await api.post('api/work/member/phone', {
        external_userid: externalUserId,
        phone: phone
    });
    return response.data;
};
export const tablePress = async (externalUserId, page, limit) => {
    const response = await api.get('api/work/health/tablePress', {
        params: {
            external_userid: externalUserId,
            page: page,
            limit: limit,
        }
    });
    return response.data.data;
};
export const tableUa = async (externalUserId, page, limit) => {
    const response = await api.get('api/work/health/tableUa', {
        params: {
            external_userid: externalUserId,
            page: page,
            limit: limit,
        }
    });
    return response.data.data;
};
export const health = async (externalUserId, cursor) => {
    const response = await api.get('api/work/health/health', {
        params: {
            external_userid: externalUserId,
        }
    });
    return response.data.data;
};
export const illness = async (externalUserId, cursor) => {
    const response = await api.get('api/work/health/illness', {
        params: {
            external_userid: externalUserId,
        }
    });
    return response.data.data.list;
};
export const medicine = async (externalUserId, cursor) => {
    const response = await api.get('api/work/health/medicine', {
        params: {
            external_userid: externalUserId,
        }
    });
    return response.data.data.list;
};
export const orderList = async (params) => {
    const response = await api.get('api/work/order/list', {
        params: params
    });
    return response.data.data;
};
export const dkorderList = async (params) => {
    const response = await api.get('api/work/order/scrmList', {
        params: params,
    });
    return response.data.data;
};
export const refundList = async (params) => {
    const response = await api.get('api/work/order/refundList', {
        params: params
    });
    return response.data.data;
};
export const expressQuery = async (params) => {
    const response = await api.get('api/work/order/expressQuery', {
        params: params
    });
    return response.data.data;
};
export const equipments = async (params) => {
    const response = await api.get('api/work/member/equipments', {
        params: params
    });
    return response.data.data;
};
export const bindEquipment = async (data) => {
    const response = await api.post('api/work/member/bindEquipment', data);
    return response.data;
};
export const unbindEquipment = async (data) => {
    const response = await api.post('api/work/member/unbindEquipment', data);
    return response.data;
};
export const qiWeiPasswordLogin = async (data) => {
    const response = await crmApi.post('/inner/qiWeiPasswordLogin', data);
    return response.data;
};
export const qiWeiUserIdToToken = async (data) => {
    const response = await crmApi.post('/inner/qiWeiUserIdToToken', data);
    return response.data;
};
export const customerSearch = async (params) => {
    const response = await crmApi.get('/api/customer/all', {
        params: {
            mobile: params.mobile || '',
            keyword: params.keyword || ''
        }
    });
    return response.data;
};
export const customerServiceLog = async (params) => {
    const response = await crmApi.get('/api/customer/serviceLog', {
        params: {
            customer_id: params.customer_id
        }
    });
    return response.data;
};
export const customerServiceAdd = async (data) => {
    const response = await crmApi.post('/api/customer/service', {
        customer_id: data.customer_id,
        remark: data.remark,
        service_type: data.service_type || ''
    });
    return response.data;
};
export default api;
